<validation-list :id="$vId(this)">
  <validation-list-item
    cols="10"
    :item="item"
    v-for="(item, key) in validationList"
    :id="$vId(this, item.id)"
  >
    <template #title>{{item.title}}</template>
    <template #content>
      <div class="mt-line" v-if="(item.items[0] || {}).description">
        <p
          class="mt-serif mt-serif--size5"
          v-html="(item.items[0].description)"
        ></p>
      </div>
      <fou-group bottom="medium" v-for="(validation, k) in item.items" :key="k">
        <ul class="mt-line mt-list mt-list--disc" v-if="validation.binary">
          <li
            class="mt-list-item mt-serif mt-serif--size5"
            v-for="binary in validation.binary"
          >
            {{`${binary}`}}<span
              v-if="validation.info"
              class="mt-serif mt-serif--size5"
              v-html="': ' + $sanitize(validation.info.details)"
            ></span>
          </li>
        </ul>
        </fou-group
      >
    </template>
  </validation-list-item>
</validation-list>
